<template>
    <div>
        <Title>设计输入需求</Title>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value3">{{ extra.projectName }}</div>

            <div class="label">设计编号</div>
            <div class="value1">{{ extra.designNo }}</div>
            <div class="label">阶段</div>
            <div class="value2">{{ extra.phaseName }}</div>

            <div class="label">专业</div>
            <div class="value1">
                <DataDictFinder dictType="cosys.major" :dictValue="extra.majors" />
            </div>
            <div class="label">设计负责人</div>
            <div class="value2">{{ extra.designLeaderName }}</div>

            <div class="label">专业负责人</div>
            <div class="value1">{{ extra.majorLeaderNames }}</div>
            <div class="label">总工程师</div>
            <div class="value2">{{ extra.chiefEngineerName }}</div>

            <div class="label">校对</div>
            <div class="value4">{{ extra.auditorNames }}</div>

            <div class="label full-label">需求内容</div>
            <div class="value4">{{ extra.reqContent }}</div>

            <div class="label">附件</div>
            <div class="value3">
                <template v-if="extra.attachment">
                    <div v-for="(item, index) in attachmentList" :key="index">
                        <a :href="item.url" target="_blank" @click.prevent="handleFileClick($event, item.url, item.name)">{{ item.name }}</a>
                    </div>
                </template>
            </div>
        </div>
        <Padding />
    </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../Title";
export default {
    components: {
        Title,
    },
    computed: {
        ...mapState("approval", ["detail"]),
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        attachmentList() {
            if (!this.extra.attachment) return [];
            return this.extra.attachment.split(",").filter(Boolean).map(url => {
                const decodedUrl = this.deepDecodeURIComponent(url);
                let name;
                try {
                    name = decodeURIComponent(this.$getFileName(url));
                } catch (e) {
                    name = this.$getFileName(url);
                }
                return { url: decodedUrl, name };
            });
        },
    },
    methods: {
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        deepDecodeURIComponent(str) {
            // 仅当结果中仍含 %25（编码的百分号）时才继续解码：
            // %25 是"还有一层编码未解"的唯一信号；没有 %25 时再解码会破坏
            // URL 中合法的编码字符（如文件名的 %2B、OSS 签名参数的 %2F），导致下载/查看链接失效
            let decoded = str;
            while (decoded.includes('%25')) {
                const prev = decoded;
                try {
                    decoded = decodeURIComponent(decoded);
                } catch (e) {
                    break;
                }
                if (decoded === prev) break;
            }
            return decoded;
        },
        handleFileClick(event, url, filename) {
            event.preventDefault();
            const decodedUrl = this.deepDecodeURIComponent(url);
            if (this.isPdfFile(filename)) {
                this.previewPdf(decodedUrl, filename);
            } else {
                const a = document.createElement('a');
                a.href = decodedUrl;
                a.download = filename || '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .full-label {
        grid-column-start: 1;
        grid-column-end: 2;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value4 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }
}
</style>
